import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { ILoadWithVin } from 'apps/fleet-planner/types'
import { CarrierInlineDisplay } from '../atoms/CarrierInlineDisplay'
import { DispatcherInlineDisplay } from '../atoms/DispatcherInlineDisplay'
import { DriverInlineDisplay } from '../atoms/DriverInlineDisplay'
import { TrailerInlineDisplay } from '../atoms/TrailerInlineDisplay'
import { TruckInlineDisplay } from '../atoms/TruckInlineDisplay'

interface ILoadAssignmentInlineDisplayProps {
  value: ILoadWithVin | null | undefined
  /**
   * @default false
   */
  missingDriver?: boolean
  /**
   * @default false
   */
  missingTruckNumber?: boolean
  /**
   * @default false
   */
  missingVin?: boolean
}

export const LoadAssignmentInlineDisplay = memo<ILoadAssignmentInlineDisplayProps>(
  ({ missingDriver = false, missingTruckNumber = false, missingVin = false, value }) => {
    const { motorCarrier, drivers = [], truck, trailer, dispatcher, isExternal } = value || {}
    const [firstDriver, secondDriver] = drivers || []

    return (
      <Box>
        <Box mb={1}>
          <CarrierInlineDisplay value={motorCarrier?.legalName} />
        </Box>
        <Box mb={1}>
          <DriverInlineDisplay
            value={firstDriver}
            label={secondDriver ? 'Driver 1' : 'Driver'}
            missingDriver={missingDriver}
          />
        </Box>
        {secondDriver && (
          <Box mb={1}>
            <DriverInlineDisplay value={secondDriver} label='Driver 2' />
          </Box>
        )}
        <Box mb={1}>
          <TruckInlineDisplay
            value={truck}
            isExternal={isExternal}
            missingTruckNumber={missingTruckNumber}
            missingVin={missingVin}
          />
        </Box>
        <Box mb={1}>
          <TrailerInlineDisplay value={trailer} />
        </Box>
        <Box mb={1}>
          <DispatcherInlineDisplay value={dispatcher} />
        </Box>
      </Box>
    )
  }
)
